<form [formGroup]="apiConfigurationResponseForm" class="form">
    <div class="form-container" [ngClass]="{ readonly: apiConfigurationState.$mode() === FormMode.Reading }">
        <div class="form-item">
            <mat-form-field>
                <mat-label>Format de la réponse</mat-label>
                <mat-select formControlName="responseFormatType" tabindex="1">
                    @for (responseFormatType of responseFormatTypes | keyvalue; track responseFormatType.key) {
                        <mat-option [value]="responseFormatType.key">
                            {{ responseFormatType.value }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
        @if (context.apiConfigurationContext.restApiConfiguration.contextOfUse === ContextOfUse.WorkflowAction) {
            <div class="form-table">
                <mat-form-field>
                    <mat-label>Variables</mat-label>
                    <app-variables-form formControlName="responseVariableConfigurations" />
                </mat-form-field>
            </div>
        }
        @if (context.apiConfigurationContext.restApiConfiguration.contextOfUse === ContextOfUse.AutocompletionDatasource) {
            <div class="form-item">
                <mat-form-field>
                    <mat-label>Chemin de la source de données</mat-label>
                    <input matInput type="text" formControlName="datasourcePath" autocomplete="off" tabindex="2" />
                </mat-form-field>
            </div>
        }
    </div>
</form>

<div class="wizard-step-buttons">
    @if (apiConfigurationState.$mode() !== FormMode.Reading) {
        <button mat-raised-button (click)="onCancelClick()">Annuler</button>
        <button
            mat-raised-button
            class="accent-button"
            [disabled]="apiConfigurationResponseForm.invalid"
            [ngClass]="{ disabled: apiConfigurationResponseForm.invalid }"
            (click)="onSaveClick()">
            Enregistrer
        </button>
    }
</div>
